import React, { useEffect } from 'react';
import { querySelectorWithShadowRoot } from 'platform/utilities/ui/webComponents';
import { useSelector } from 'react-redux';
import { capitalizeFirstLetter } from '../helpers';

const PrivacyPolicy = () => {
  const formData = useSelector(state => state?.form?.data ?? {});

  const title = formData?.authorizedOfficial?.title;

  const removeNoteText = async () => {
    const noteText = await querySelectorWithShadowRoot(
      'p.font-sans-6',
      document.querySelector('va-statement-of-truth'),
    );
    noteText?.setAttribute('style', 'display:none;');
  };

  const removeOldPrivacyPolicy = async () => {
    const privacyPolicyText = await querySelectorWithShadowRoot(
      'p.short-line',
      document.querySelector('va-statement-of-truth'),
    );
    privacyPolicyText?.setAttribute('style', 'display:none;');
  };

  useEffect(() => {
    const initializeComponent = async () => {
      // Hide "Note" above Certification statement
      await removeNoteText();
      // Hide platform line for privacy policy, use custom
      await removeOldPrivacyPolicy();
    };

    initializeComponent();
  }, []);

  return (
    <>
      <p>
        I certify that my entries are true and correct to the best of my
        knowledge. I acknowledge that:
      </p>
      <ul>
        <li>
          This agreement will be valid for the full academic year starting
          August 1, unless my institution notifies VA of changes during an open
          enrollment period.
        </li>
        <li>
          The agreement must be signed by an official who is legally authorized
          to bind the school, such as the President, Chief Administrative
          Officer, or an equivalent official. It cannot be signed by the SCO or
          other personnel unless they hold one of these titles. The signed
          agreement must be submitted to VA by May 15, or the following Monday
          if May 15 falls on a weekend. Late submissions will not be accepted.
        </li>
        <li>
          At least one of my school’s programs must be approved for VA benefits
          and must include tuition or fees that exceed what the GI Bill covers.
        </li>
      </ul>
      <p>
        The terms of this agreement should be available on the GI Bill
        Comparison Tool approximately mid-June.
      </p>
      <span data-testid="privacy-policy-text">
        I have read and accept the{' '}
        <va-link
          text="privacy policy"
          aria-label="View the privacy policy"
          href="/privacy-policy"
          external
        />
        .
      </span>
      <p className="vads-u-margin-bottom--0">Your title</p>
      <strong>
        <p className="vads-u-font-size--h3 vads-u-margin-top--0">
          {capitalizeFirstLetter(title)}
        </p>
      </strong>
    </>
  );
};

export default PrivacyPolicy;
